import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=15c0e624"
import script from "./SubItem.vue?vue&type=script&lang=ts"
export * from "./SubItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports